import { useQuery, gql } from '@apollo/client'

const TESTIMONIALS_LIMIT = 3

const EXPERT_TESTIMONIALS_QUERY = gql`
  query expertTestimonialsQuery(
    $id: Int!
    $testimonialsInput: TestimonialsInput
  ) {
    expertMe(id: $id) {
      testimonials(input: $testimonialsInput) {
        data {
          id
          feedback
          clientName
          consultationName
        }
      }
    }
  }
`

export const useExpertTestimonialsQuery = (id) => {
  const { data, ...restResult } = useQuery(EXPERT_TESTIMONIALS_QUERY, {
    variables: {
      id,
      testimonialsInput: {
        pagination: {
          limit: TESTIMONIALS_LIMIT,
        },
      },
    },
  })
  const testimonials = data?.expertMe?.testimonials.data ?? []
  return { testimonials, ...restResult }
}
